module.exports = __webpack_public_path__ + "images/160_160.jpg";